import boxShadows from "assets/theme/box-shadow.js";
import themeColors from "assets/theme/colors";

const componentStyles = (theme) => ({
  cardRootBgGradient: {
    background:
      "linear-gradient(87deg," +
      themeColors.dark.main +
      ",#1a174d)!important",
  },
  cardRoot: {
    boxShadow: boxShadows.boxShadow + "!important",
    border: "0!important",
  },
  cardHeaderRoot: {
    backgroundColor: "initial!important",
  },
  textUppercase: {
    textTransform: "uppercase",
  },
  buttonRootUnselected: {
    background: themeColors.white.main + "!important",
    color: themeColors.primary.main + "!important",
  },
});

export default componentStyles;
